import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'input1-callback',
    template: ``
})
export class Input1CallbackComponent implements OnInit {
    constructor(public route : ActivatedRoute) {}

    ngOnInit() {
        const routeQueryParams = this.route.snapshot.queryParams;
        window.parent.postMessage({'messageType': 'input1Callback', 'queryParams': routeQueryParams}, '*');
    }
}
